module.exports = __webpack_public_path__ + "img/fbcafe.dcba80b2.svg";